import React from "react";
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { EnvironmentProvider } from "./context/EnvironmentContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import PermissionRoute from "./components/auth/PermissionRoute";
import AppLayout from "./components/layout/AppLayout";
import LoginPage from "./pages/Login/LoginPage";
import HomePage from "./pages/Home/HomePage";
import ConfigEditor from "./pages/Config/ConfigEditor";
import AuditLogPage from "./pages/Audit/AuditLogPage";
import UserManagementPage from "./pages/Users/UserManagementPage";
import RoleManagementPage from "./pages/Roles/RoleManagementPage";
import GoogleAnalyticsPage from "./pages/Analytics/GoogleAnalyticsPage";
import SqlConsolePage from "./pages/SqlConsole/SqlConsolePage";
import StatusPage from "./pages/Status/StatusPage";
import NotFound from "./pages/NotFound/NotFound";
import ChartAgentPage from "./labs/chart-agent/ChartAgentPage";
import SqAiPage from "./labs/sq-ai/SqAiPage";
import "./App.css";

export default function App() {
  return (
    <AuthProvider>
      <EnvironmentProvider>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/home" element={<HomePage />} />
            <Route path="/configuration/editor" element={<ConfigEditor />} />
            <Route path="/audit-logs" element={<AuditLogPage />} />
            <Route
              path="/users"
              element={
                <PermissionRoute perm="users:manage">
                  <UserManagementPage />
                </PermissionRoute>
              }
            />
            <Route
              path="/roles"
              element={
                <PermissionRoute perm="roles:edit">
                  <RoleManagementPage />
                </PermissionRoute>
              }
            />
            <Route
              path="/analytics/google"
              element={
                <PermissionRoute perm="analytics:view_google_analytics">
                  <GoogleAnalyticsPage />
                </PermissionRoute>
              }
            />
            <Route
              path="/status"
              element={
                <PermissionRoute perm="monitoring:view_status_page">
                  <StatusPage />
                </PermissionRoute>
              }
            />
            <Route
              path="/sql-console"
              element={
                <PermissionRoute perm="users:manage">
                  <SqlConsolePage />
                </PermissionRoute>
              }
            />
          </Route>
          {/* /ai is a standalone full-screen route — owns its own layout
              (left rail + chat pane), so it sits outside AppLayout. */}
          <Route
            path="/ai"
            element={
              <ProtectedRoute>
                <ChartAgentPage />
              </ProtectedRoute>
            }
          />
          {/* /sq-ai is the CEO sandbox for the chart-mode agent — also
              full-screen and outside AppLayout, deliberately separate from
              the chart-agent dev UI at /ai. */}
          <Route
            path="/sq-ai"
            element={
              <ProtectedRoute>
                <SqAiPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </EnvironmentProvider>
    </AuthProvider>
  );
}
